import React, { createContext, useContext } from 'react';
import { useCategories } from '../hooks/useCategories';

const CategoriesContext = createContext();

export function CategoriesProvider({ children }) {
  const categoriesData = useCategories();
  
  return (
    <CategoriesContext.Provider value={categoriesData}>
      {children}
    </CategoriesContext.Provider>
  );
}

export function useCategoriesContext() {
  const context = useContext(CategoriesContext);
  if (!context) {
    throw new Error('useCategoriesContext must be used within a CategoriesProvider');
  }
  return context;
}